export function requireField(value, fieldName) {
  if (value === undefined || value === null || value === '') {
    throw new Error(`Missing required field: ${fieldName}`);
  }
}

export function ensureArray(value, fieldName) {
  if (!Array.isArray(value)) {
    throw new Error(`Expected array for ${fieldName}`);
  }
}

export function ensureString(value, fieldName) {
  if (typeof value !== 'string') {
    throw new Error(`Expected string for ${fieldName}`);
  }
}
